import * as S from './styled';

interface SkeletonProps {
  width?: number | string;
  height?: number;
  marginbottom?: number;
  className?: string;
}

export function Skeleton({
  width = '100%',
  height = 300,
  marginbottom = 12,
  className,
}: SkeletonProps) {
  return (
    <S.SkeletonWrapper
      width={width}
      height={height}
      marginbottom={marginbottom}
      className={className}
    />
  );
}
